import React from 'react';
import { ScrollTextIcon, PrinterIcon, TimerIcon, ListOrderedIcon, LayersIcon, UsersIcon } from 'lucide-react';
const coverage = [{
  label: 'What you get',
  body: 'Today’s session, already written word for word — not a topic to research',
  Icon: ScrollTextIcon
}, {
  label: 'Every week',
  body: 'Open the volume, print today’s worksheet, teach it as-is',
  Icon: PrinterIcon
}, {
  label: 'Any time slot',
  body: 'Every session in Short 20, Standard 45 or Full 60 minutes',
  Icon: TimerIcon
}, {
  label: 'Right order',
  body: 'Pieces → tactics → endgames → openings → plans → tournaments',
  Icon: ListOrderedIcon
}, {
  label: 'Any level',
  body: 'Every session runs at beginner, improver and ready-to-play',
  Icon: LayersIcon
}, {
  label: 'Few boards',
  body: 'Built for 30 kids and 8 sets — nobody standing around',
  Icon: UsersIcon
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-navy-mid" data-id="element-205" data-mp="1b17dmjoti6dx">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-206" data-mp="1f1rb5odazc0l">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-207" data-mp="1jt9euk6pnqp9">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="chalk-underline mt-3 font-display text-white text-[28px] sm:text-5xl" data-id="element-208" data-mp="1osvrarept2x0">
          The Print-and-Teach Club System
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/75" data-id="element-209" data-mp="w2wuuay6y3ib">
          The whole season comes planned, sequenced and scripted. It’s not a
          stack of loose lessons you have to assemble &mdash; it’s “what we do
          in club on Tuesday.” You open the volume, print today’s worksheet,
          and teach it.
        </p>

        <ul className="mt-8 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-210" data-mp="2ck122s5st50g">
          {coverage.map(({
          label,
          body,
          Icon
        }) => <li key={label} className="flex items-start gap-3 rounded-lg border border-navy-line bg-white/5 px-4 py-3.5" data-id="element-211" data-mp="1rscmdm481rfl">
              <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-md bg-gold/15 text-gold" data-id="element-212" data-mp="1mvvrm92ioetj">
                <Icon className="h-4 w-4" aria-hidden="true" data-id="element-213" data-mp="1ws8hswyusajj" />
              </span>
              <span data-id="element-214" data-mp="1wq4bk8dhezg3">
                <span className="block text-[11px] font-bold uppercase tracking-widest text-gold" data-id="element-215" data-mp="191uxjsmiffzi">
                  {label}
                </span>
                <span className="mt-1 block text-sm text-white/85" data-id="element-216" data-mp="1454j19qcssg7">{body}</span>
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}